"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GatewayService = void 0;
var _gateway = require("../controllers/gateway.controller");
var isSurveyApp = function isSurveyApp() {
  var _window, _window$location, _window$location$href;
  var urlParts = (_window = window) === null || _window === void 0 ? void 0 : (_window$location = _window.location) === null || _window$location === void 0 ? void 0 : (_window$location$href = _window$location.href) === null || _window$location$href === void 0 ? void 0 : _window$location$href.split("/");
  return (urlParts === null || urlParts === void 0 ? void 0 : urlParts.includes("surveys")) || (urlParts === null || urlParts === void 0 ? void 0 : urlParts.includes("survey"));
};
var GatewayService = {
  getUser: _gateway.config.serviceURL + "/get",
  authenticate: _gateway.config.serviceURL + "/authenticate",
  refreshToken: process.env.REACT_APP_CLIENT === "tenant" ? isSurveyApp() ? "/surveyorservice/v1/api/survey/public/refreshtoken?refreshToken=" : "/recordsservice/v1/api/records/public/refreshtoken?refreshToken=" : _gateway.config.serviceURL + "/refreshToken?refreshToken=",
  ssoToken: "/userservice/v1/api/authenticate/sso?token="
};
exports.GatewayService = GatewayService;